export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/about-me.jpg" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
            I'm Sai Varun, a passionate and driven Data Scientist and Full-Stack
            Developer pursuing an Integrated MTech in Data Science at Vellore
            Institute of Technology, Vellore. My journey in technology has been
            fueled by curiosity and a desire to solve real-world problems using
            data and innovative solutions.
          </p>
          <p className="hero--section-description">
            Beyond academics, I find joy in dancing, acting, coding, and gaming,
            as these hobbies inspire my creativity and help me approach
            challenges from unique perspectives. I am constantly learning and
            evolving, with a vision to contribute to the fields of data science
            and AI by delivering sustainable and innovative solutions. I believe
            in combining technical expertise, creative thinking, and a
            collaborative mindset to make a meaningful impact.
          </p>
        </div>
      </div>
    </section>
  );
}
